import { PriceComponent } from '../../price/client/price.component';

export class PriceFeatureComponentComponent extends PriceComponent {}
